let isDragging = false
let currentDragElement = null
let didDrag = false

class ColourEmitter extends EventTarget {
  changed() {
    this.dispatchEvent(new Event('colour-change'))
  }
}

const colourEmitter = new ColourEmitter()

function openColorPicker(event) {
  if (event.detail > 1 || didDrag) return

  const colorPicker = document.getElementById('colorPicker')
  const colorLine = document.getElementById('colorLine')
  const xPosition = event.clientX - colorLine.getBoundingClientRect().left

  currentDragElement = null

  colorPicker.style.left = `${xPosition}px`
  colorPicker.setAttribute('data-xposition', xPosition)
  colorPicker.click()
}

function addPoint(color, xPosition) {
  let colorPoint
  if (currentDragElement) {
    colorPoint = currentDragElement
  } else {
    colorPoint = document.createElement('div')
    colorPoint.className = 'colorPoint'
    colorPoint.style.left = `${ xPosition }px`

    colorPoint.addEventListener('dblclick', function () {
      this.remove()
    })

    colorPoint.addEventListener('mousedown', function (event) {
      isDragging = true
      currentDragElement = this
      didDrag = false
      document.addEventListener('mousemove', onDrag)
      document.addEventListener('mouseup', stopDrag)
    })

    colorPoint.addEventListener('click', function(event) {
      if (didDrag) return

      event.stopPropagation()

      if (event.shiftKey) {
        this.remove()
        create()
        return
      }

      currentDragElement = this
      colorPicker.style.display = 'block'
      const hex = colorPoint.style.background.match(/\d+/g)
        .map(Number)
        .map(n => n.toString(16).padStart(2, '0'))
        .join('')
      colorPicker.value = `#${hex}`
      colorPicker.click()
    })

  }
  colorPoint.style.background = color


  document.getElementById('colorLine').appendChild(colorPoint)
}

function setColor(event) {
  const color = event.target.value
  const xPosition = event.target.getAttribute('data-xposition')

  addPoint(color, xPosition)

  create()
}

function onDrag(event) {
  if (!isDragging) return
  const colorLine = document.getElementById('colorLine')
  const xPosition = event.clientX - colorLine.getBoundingClientRect().left

  if (xPosition >= 0 && xPosition <= colorLine.offsetWidth) {
    currentDragElement.style.left = `${xPosition}px`
    didDrag = true
    create()
  }
}

function stopDrag(event) {
  setTimeout(() => {
    isDragging = false
    didDrag = false
  }, 200)
  document.removeEventListener('mousemove', onDrag)
  document.removeEventListener('mouseup', stopDrag)
  create()
}

function getPointsArray() {
  const colorPoints = document.querySelectorAll('.colorPoint')
  const colorLineWidth = document.getElementById('colorLine').offsetWidth

  if (colorLineWidth === 0) {
    return []
  }

  let pointsArray = []

  for (let point of colorPoints) {
    const t = parseInt(point.style.left, 10) / colorLineWidth
    const rgb = point.style.background.match(/\d+/g).map(Number)
    pointsArray.push({ c: rgb, t })
  }

  const array = pointsArray.sort((a, b) => a.t - b.t)
  if (array.length === 1) {
    array.push(array[0])
  }
  array[0].t = 0
  array[array.length - 1].t = 1
  return array
}

const pairs = a => {
  const b = a.slice(1)
  return a.slice(0, -1).map((e, i) => ([e, b[i]]))
}
function rec(a, f, o=[]) {
  const [h, ...t] = a
  return h === undefined ? o : rec(t, f, o.concat(f(h, o.slice(-1)[0], o.length)))
}

function computeCubicSpline(ps) {
  const h = pairs(ps).map(([a, b]) => b.x-a.x)
  const b = pairs(ps).map(([a, b], i) => (b.y-a.y) / h[i])

  const u = rec(pairs(h), ([a, b], l) => 2*(a+b) - (l === undefined ? 0 : b*b/l))
  const v = rec(pairs(b), ([a, b], l, i) => 6*(b-a) - (l === undefined ? 0 : h[i]*l/u[i]))

  const z = Array(ps.length).fill(0)
  for (let i = ps.length - 2; i >= 1; i--) {
    z[i] = (v[i-1] - h[i] * z[i + 1]) / u[i-1]
  }

  return pairs(ps).map(([p, q], i) => {
    let a = p.y
    let b = -h[i]/6 * z[i+1] - h[i]/3 * z[i] + (q.y-p.y)/h[i]
    let c = z[i]/2
    let d = (z[i+1] - z[i]) / (6*h[i])
    return { a, b, c, d }
  })
}

function cubicInterp(splines, points, x) {
  for (let i = 0; i < points.length - 1; i++) {
    if (x > points[i].x && x < points[i+1].x) {
      const { a, b, c, d } = splines[i]
      const dx = x - points[i].x
      return a + dx*(b + dx*(c + d*dx))
    }
  }
}

const lerp = (p1, p2, t) => {
  return p1.map((val, i) => (val + (p2[i] - val) * t))
}

function interpolate(points, cubic) {
  if (cubic) {
    const cols = [0, 1, 2].map(i=> points.map(p => ({ x: p.t, y: p.c[i] })))
    const splines = cols.map(computeCubicSpline)
    const output = Array(256).fill(0).map((e, x) => {
      return { c: splines.map((spline, i) => cubicInterp(spline, cols[i], x / 255)) }
    })
    output[0].c = points[0].c
    output[255].c = points[points.length-1].c
    return output
  } else {
    return points.slice(0, -1).flatMap((p, i) => {
      const q = points[i + 1]
      const dt = q.t - p.t
      const length = Math.ceil(dt * 255)
      const step = dt / length
      return Array.from({ length }, (_, j) => {
        return ({ c: lerp(p.c, q.c, j / length), t: p.t + j / length * dt })
      })
    })
  }
}

function xyzToRgb(x, y, z) {
  const toSRGB = val => {
    val = (val > 0.0031308) ? 1.055 * Math.pow(val, 1/2.4) - 0.055 : 12.92 * val
    return Math.max(0, Math.min(255, Math.round(val * 255)))
  }

  const matrix = [
    [3.2404542, -1.5371385, -0.4985314],
    [-0.9692660, 1.8760108, 0.0415560],
    [0.0556434, -0.2040259, 1.0572252]
  ]

  return matrix.map(([m1, m2, m3]) => toSRGB(m1 * x + m2 * y + m3 * z))
}


function rgbToXyz(r, g, b) {
  const toLinear = val => {
    val /= 255
    return (val > 0.04045) ? Math.pow((val + 0.055) / 1.055, 2.4) : val / 12.92
  }

  [r, g, b] = [r, g, b].map(toLinear)

  const matrix = [
    [0.4124564, 0.3575761, 0.1804375],
    [0.2126729, 0.7151522, 0.0721750],
    [0.0193339, 0.1191920, 0.9503041]
  ]

  const [x, y, z] = matrix.map(([m1, m2, m3]) => m1 * r + m2 * g + m3 * b)

  return [x, y, z]
}

const wrap = (f, { p, c }) => ({p: f(p), c})
let customCM
function create() {
  const xyz = document.querySelector('#xyz').checked
  const cubic = document.querySelector('#cubic').checked

  if (xyz) {
    const xyz = getPointsArray().map(({ c, t }) => ({ c: rgbToXyz(...c), t }))
    customCM = interpolate(xyz, cubic).map(({ c, t }) => ({ c: xyzToRgb(...c) }))
  } else {
    customCM = interpolate(getPointsArray(), cubic)
  }


  const div = document.querySelector('#cm')
  div.innerHTML = ''
  customCM.forEach(({ c }) => {
    let e = document.createElement('div')
    const [r, g, b] = c
    e.style.backgroundColor = `rgb(${r}, ${g}, ${b})`
    div.appendChild(e)
  })

  const pointsArrayJSON = JSON.stringify(getPointsArray(), null, 2)
  document.querySelector('code').innerHTML = pointsArrayJSON

  localStorage.setItem('pointsArray', pointsArrayJSON)

  customCM = customCM.map(({c}) => ([c[0]/255, c[1]/255, c[2]/255]))
  colourEmitter.changed()
}


document.getElementById('colorLine').addEventListener('click', openColorPicker)
document.getElementById('colorPicker').addEventListener('change', setColor)
document.querySelector('#xyz').addEventListener('change', create)
document.querySelector('#cubic').addEventListener('change', create)

// const limits = [[0, 0], [255, 800]]
// limits.forEach(([c, v]) => {
//   addPoint(`rgb(${c}, ${c}, ${c})`, v)
// })
//
// addPoint('rgb(255, 0, 0)', 200)
// addPoint('rgb(0, 255, 0)', 500)

function fromPointsArrayJSON(json) {
  document.getElementById('colorLine').innerHTML = ''
  for (const { c, t } of JSON.parse(json)) {
    const [r, g, b] = c
    addPoint(`rgb(${r}, ${g}, ${b})`, t * 800)
  }
  create()
}

const existing = localStorage.getItem('pointsArray')
if (existing) {
  fromPointsArrayJSON(existing)
} else {
  addPoint('rgb(147, 105, 31)', 0)
  addPoint('rgb(142, 107, 47)', 0.1125 * 800)
  addPoint('rgb(217, 175, 58)', 0.3 * 800)
  addPoint('rgb(210, 163, 81)', 0.5775 * 800)
  addPoint('rgb(255, 255, 255)', 800)
  create()
}


document.querySelector("#set-colour-points").addEventListener('click', () => {
  fromPointsArrayJSON(window.prompt("colour codes:"))
})

////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////



const colormaps = require('./colourmaps.js')

const usingBrowser = typeof window === 'object'

const clamp = (l, m=230) => l.map(e => Math.floor(Math.max(0, Math.min(255, e * m))))

const s2 = (q, p, k) => {
  const s = p[`s_${k}`], b = p[`b_${k}`]
  return q[k].map(v => v*v / (1 + s*v*v) + b)
}

const dcy = (q, p, k) => {
  const l = q[k], D = p[`D_${k}`], r = p[`r_${k}`]
  return l.map((v, i) => D*((i === 0 ? v : l[i-1]) - 2*v + (i === l.length - 1 ? v : l[i+1])) - r*v)
}

function iter(q, p) {
  const [as2, cs2] = ['a', 'c'].map(c => s2(q, p, c))
  const [da, db, dc, dd] = ['a', 'b', 'c', 'd'].map(c => dcy(q, p, c))
  q.a = q.a.map((a, i) => a + p.s*q.c[i]*q.b[i]*as2[i] + da[i])
  q.b = q.b.map((b, i) => b + p.b_b - p.s*q.c[i]*b*as2[i] + db[i])
  q.c = q.c.map((c, i) => c + p.r_c*(cs2[i]/(q.d[i] + p.c_c*q.b[i] + p.s_e*q.e[i])) + dc[i])
  q.d = q.d.map((d, i) => d + p.r_c*cs2[i] + dd[i])
  q.e = q.e.map((e, i) => e + p.b_e*q.c[i] - p.r_e*e)
}

const genp = (pre, subs) => Object.fromEntries(Array.from(subs).map(k => [`${pre}_${k}`, 1]))


const p = {
  s: 0.12,
  iterations: 7,
}

Object.assign(p, genp('D', 'abcd'))
Object.assign(p, genp('r', 'abcde'))
Object.assign(p, genp('b', 'abce'))
Object.assign(p, genp('s', 'abce'))
Object.assign(p, genp('c', 'bc'))


p.D_a = 0.05
p.D_b = 0.1
p.D_c = 0.01
p.D_d = 0
p.r_a = 0.12
p.r_b = 0.003
p.r_c = 0.04
p.r_d = 0.05
p.r_e = 0.002
p.b_a = 0.01
p.b_b = 0.06
p.b_c = 0.0
p.b_e = 0.002
p.s_a = 1
p.s_b = 0.0
p.s_c = 0.4
p.s_e = 0.08
p.c_b = 0
p.c_c = 0.002

function randomiseParams() {
  for (const k in p) {
    const a = 1
    if (k != 'iterations') {
      const b = p[k]
      p[k] *= 1 + Math.random() * a - a / 2
      p[k] = Math.max(0, p[k])
    }
  }
}

// const rand = Array(N).fill(0).map(e => Array(N).fill(0).map(f => Math.random()))
let q = null
let qbak = null

function draw(canvas, exportCanvas, cmn) {
  const ctx = canvas.getContext("2d", { willReadFrequently: true })
  const w = canvas.offsetWidth, h = canvas.offsetHeight, n = w * h
  const data = ctx.getImageData(0, 0, w, h)
  const N = canvas.offsetWidth

  if (!q) {
    q = {
      // a: Array(N).fill(0).map((v, i) => Math.sin(i*0.05) * 0.5 + 0.5),
      a: Array(N).fill(0).map((v, i) => Math.random()),
      b: Array(N).fill(0).map(() => Math.random()),
      // c: Array(N).fill(0).map((v, i) => Math.sin(i*0.05) * 0.5 + 0.5),
      c: Array(N).fill(0).map((v, i) => Math.random()),
      d: Array(N).fill(0).map(() => Math.random()),
      e: Array(N).fill(0).map(() => Math.random()),
    }
    qbak = JSON.stringify(q)
  } else {
    q = JSON.parse(qbak)
  }


  if (!cmn) {
    cmn = document.querySelector('#colormaps').selectedOptions[0].value
  }
  const cm = cmn === "custom" ? customCM : colormaps[cmn]

  const pixels = data.data
  let k, v, vv, z

  const output = []

  let col1, col2, ectx, exportData, exportPixels
  if (exportCanvas) {
    const toCol = v => [0, 1, 2].map(i => parseInt(v.substr(i*2+1, 2), 16))
    col1 = toCol(document.querySelector('#col1').value)
    col2 = toCol(document.querySelector('#col2').value)
    ectx = exportCanvas.getContext("2d", { willReadFrequently: true })
    exportData = ectx.getImageData(0, 0, 200, 200)
    exportPixels = exportData.data
  }

  const start = +(new Date())

  // console.log('cm', cm)

  for (let y = 0; y < h; y++) {
    for (let j = 0; j < p.iterations; j++)
      iter(q, p)

    v = clamp(q.a)
    if (y > 10) output.push(v)

    for (let x = 0; x < w; x++) {
      k = (x + y * w) * 4
      vv = v[x]
      const [r, g, b] = cm[vv]
      pixels[k] = r * 255
      pixels[k+1] = g * 255
      pixels[k+2] = b * 255
      pixels[k+3] = 255

      if (exportCanvas && x % 2 == 0 && y % 2 === 0) {
        k = (x/2 + y/2 * 200) * 4
        const c = vv < 127 ? col1 : col2
        exportPixels[k] = c[0]
        exportPixels[k+1] = c[1]
        exportPixels[k+2] = c[2]
        exportPixels[k+3] = 255
      }
    }
  }

  const took = +(new Date()) - start
  console.log('took', took)

  ctx.putImageData(data, 0, 0)

  if (exportCanvas) {
    ectx.putImageData(exportData, 0, 0)
  }
  return output
}


function std(numbers) {
  const n = numbers.length
  const mean = numbers.reduce((sum, num) => sum + num, 0) / n
  const squaredDifferences = numbers.map(num => Math.pow(num - mean, 2))
  const variance = squaredDifferences.reduce((sum, squaredDiff) => sum + squaredDiff, 0) / n
  return Math.sqrt(variance)
}

if (usingBrowser) {
  const { hash } = window.location
  if (hash) {
    const d = JSON.parse(atob(hash.substring(1)))
    Object.assign(p, d)
  }


  const select = document.querySelector('#colormaps')
  Object.keys(colormaps).forEach((cm) => {
    const option = document.createElement('option')
    option.text = option.value = cm
    select.add(option)
  })
  const option = document.createElement('option')
  option.text = option.value = "custom"
  select.add(option)

  select.value = "twilight"

  const canvas = document.querySelector("canvas.main")
  const exportCanvas = document.querySelector("canvas.export")

  window.addEventListener("load", () => draw(canvas, exportCanvas))
  select.addEventListener("change", ({ target }) => {
    document.querySelector("#colours").style.display = target.value === "custom" ? "flex" : "none";
    create()
    draw(canvas, exportCanvas)
  })

  colourEmitter.addEventListener('colour-change', (e) => {
    draw(canvas, exportCanvas)
  })

  document.querySelector("#col1").addEventListener("change", () => draw(canvas, exportCanvas))
  document.querySelector("#col2").addEventListener("change", () => draw(canvas, exportCanvas))

  const controls = document.querySelector("div.controls")

  Object.keys(p).forEach((param) => {
    const control = document.createElement("div")
    control.classList.add("control", param)
    const input = document.createElement("input")
    input.type = "range"
    input.name = param
    input.value = p[param] * (param === 'iterations' ? 1 : 100)
    input.max = param === 'iterations' ? 10 : 100
    input.step = param === 'iterations' ? 1 : 0.1
    control.appendChild(input)
    const label = document.createElement("label")
    label.innerHTML = `${ param } (${ p[param].toFixed(3) })`
    control.appendChild(label)
    controls.appendChild(control)
  })

  const inputs = document.querySelectorAll("input")
  inputs.forEach((input) => {
    input.addEventListener("input", ({ target }) => {
      const { name, value } = target
      if (name) {
        const label = document.querySelector(`div.${ name } label`)
        p[name] = value * (name === 'iterations' ? 1 : 0.01)
        const s = name === 'iterations' ? p[name] : p[name].toFixed(3)
        label.innerHTML = `${ name } (${ s })`
        draw(canvas, exportCanvas)
      }
    })
  })

  document.querySelector('#export').addEventListener('click', () => {
    const img = exportCanvas.toDataURL("image/png")
    const a = document.createElement("a")
    a.href = img
    a.download = "sea-shell-pattern.png"
    a.click()
  })

} else {
  const fs = require('fs')
  const { createCanvas } = require('canvas')

  const canvas = createCanvas(50, 50)
  canvas.offsetWidth = canvas.width
  canvas.offsetHeight = canvas.height

  const random = Math.random().toString(30).substring(2)
  const out = fs.createWriteStream(`./outputs/${random}.png`)
  const stream = canvas.createPNGStream()
  stream.pipe(out)

  let attempts = 1
  while (true) {
    randomiseParams()
    const pix = draw(canvas, false, "bw")
    const meanStd = pix.map(std).reduce((sum, num) => sum + num, 0) / pix.length
    process.stdout.write(`\rattempt ${attempts}: ${meanStd}`)
    attempts++
    if (meanStd > 20) {
      console.log()
      break
    }
  }

  fs.writeFileSync(`./outputs/${random}.json`, JSON.stringify(p, null, 2))
  console.log('created', random)
}
